import type { SubscriptionType } from '@/@types/Subscription';
import { PRODUCTS_SLUG } from '@/shared/constants/SlugsProducts';

/**
 * Identity of the "Declaración Anual" subscription product, matched by slug.
 *
 * Matching by slug, not by product-version id: a subscription carries the pv it
 * was bought with, which is not necessarily the product's CURRENT default, so
 * comparing against `DefaultProductVersionIds.AnnualDeclarationSubscription`
 * misses anyone on an older version of the same product.
 */
export const isAnnualDeclarationSubscription = (
	subscription: SubscriptionType,
): boolean =>
	subscription?.product_version?.product?.slug ===
	PRODUCTS_SLUG.ANNUAL_DECLARATION;
